"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = require("@material-ui/core/colors");
var _styles = require("@material-ui/core/styles");
var _primary = _interopRequireDefault(require("./primary"));
var _secondary = _interopRequireDefault(require("./secondary"));
var opacity = {
  black: {
    4: (0, _styles.alpha)(_colors.common.black, 0.04),
    8: (0, _styles.alpha)(_colors.common.black, 0.08),
    14: (0, _styles.alpha)(_colors.common.black, 0.14),
    24: (0, _styles.alpha)(_colors.common.black, 0.24),
    38: (0, _styles.alpha)(_colors.common.black, 0.38),
    54: (0, _styles.alpha)(_colors.common.black, 0.54),
    60: (0, _styles.alpha)(_colors.common.black, 0.6),
    87: (0, _styles.alpha)(_colors.common.black, 0.87)
  },
  error: {
    200: {
      24: (0, _styles.alpha)(_colors.red[200], 0.24)
    },
    900: {
      4: (0, _styles.alpha)(_colors.red[900], 0.04),
      8: (0, _styles.alpha)(_colors.red[900], 0.08),
      14: (0, _styles.alpha)(_colors.red[900], 0.14),
      24: (0, _styles.alpha)(_colors.red[900], 0.24),
      38: (0, _styles.alpha)(_colors.red[900], 0.38),
      54: (0, _styles.alpha)(_colors.red[900], 0.54),
      60: (0, _styles.alpha)(_colors.red[900], 0.6),
      62: (0, _styles.alpha)(_colors.red[900], 0.62),
      86: (0, _styles.alpha)(_colors.red[900], 0.86),
      87: (0, _styles.alpha)(_colors.red[900], 0.87)
    }
  },
  ok: {
    200: {
      24: (0, _styles.alpha)(_colors.green[200], 0.24)
    },
    500: {
      4: (0, _styles.alpha)(_colors.green[500], 0.04),
      8: (0, _styles.alpha)(_colors.green[500], 0.08),
      14: (0, _styles.alpha)(_colors.green[500], 0.14),
      24: (0, _styles.alpha)(_colors.green[500], 0.24),
      38: (0, _styles.alpha)(_colors.green[500], 0.38),
      54: (0, _styles.alpha)(_colors.green[500], 0.54),
      60: (0, _styles.alpha)(_colors.green[500], 0.6),
      62: (0, _styles.alpha)(_colors.green[500], 0.62),
      86: (0, _styles.alpha)(_colors.green[500], 0.86),
      87: (0, _styles.alpha)(_colors.green[500], 0.87)
    }
  },
  primary: {
    200: {
      4: (0, _styles.alpha)(_primary["default"][200], 0.04),
      8: (0, _styles.alpha)(_primary["default"][200], 0.08),
      14: (0, _styles.alpha)(_primary["default"][200], 0.14),
      24: (0, _styles.alpha)(_primary["default"][200], 0.24),
      38: (0, _styles.alpha)(_primary["default"][200], 0.38),
      54: (0, _styles.alpha)(_primary["default"][200], 0.54),
      60: (0, _styles.alpha)(_primary["default"][200], 0.6),
      62: (0, _styles.alpha)(_primary["default"][200], 0.62),
      86: (0, _styles.alpha)(_primary["default"][200], 0.86),
      87: (0, _styles.alpha)(_primary["default"][200], 0.87)
    },
    500: {
      4: (0, _styles.alpha)(_primary["default"][500], 0.04),
      8: (0, _styles.alpha)(_primary["default"][500], 0.08),
      14: (0, _styles.alpha)(_primary["default"][500], 0.14),
      24: (0, _styles.alpha)(_primary["default"][500], 0.24),
      38: (0, _styles.alpha)(_primary["default"][500], 0.38),
      54: (0, _styles.alpha)(_primary["default"][500], 0.54),
      60: (0, _styles.alpha)(_primary["default"][500], 0.6),
      62: (0, _styles.alpha)(_primary["default"][500], 0.62),
      86: (0, _styles.alpha)(_primary["default"][500], 0.86),
      87: (0, _styles.alpha)(_primary["default"][500], 0.87)
    },
    800: {
      4: (0, _styles.alpha)(_primary["default"][800], 0.04),
      8: (0, _styles.alpha)(_primary["default"][800], 0.08),
      14: (0, _styles.alpha)(_primary["default"][800], 0.14),
      24: (0, _styles.alpha)(_primary["default"][800], 0.24),
      38: (0, _styles.alpha)(_primary["default"][800], 0.38),
      54: (0, _styles.alpha)(_primary["default"][800], 0.54),
      60: (0, _styles.alpha)(_primary["default"][800], 0.6),
      62: (0, _styles.alpha)(_primary["default"][800], 0.62),
      86: (0, _styles.alpha)(_primary["default"][800], 0.86),
      87: (0, _styles.alpha)(_primary["default"][800], 0.87)
    },
    900: {
      4: (0, _styles.alpha)(_primary["default"][900], 0.04),
      8: (0, _styles.alpha)(_primary["default"][900], 0.08),
      14: (0, _styles.alpha)(_primary["default"][900], 0.14),
      24: (0, _styles.alpha)(_primary["default"][900], 0.24),
      38: (0, _styles.alpha)(_primary["default"][900], 0.38),
      54: (0, _styles.alpha)(_primary["default"][900], 0.54),
      60: (0, _styles.alpha)(_primary["default"][900], 0.6),
      62: (0, _styles.alpha)(_primary["default"][900], 0.62),
      86: (0, _styles.alpha)(_primary["default"][900], 0.86),
      87: (0, _styles.alpha)(_primary["default"][900], 0.87)
    }
  },
  secondary: {
    800: {
      4: (0, _styles.alpha)(_secondary["default"][800], 0.04),
      8: (0, _styles.alpha)(_secondary["default"][800], 0.08),
      14: (0, _styles.alpha)(_secondary["default"][800], 0.14),
      24: (0, _styles.alpha)(_secondary["default"][800], 0.24),
      38: (0, _styles.alpha)(_secondary["default"][800], 0.38),
      54: (0, _styles.alpha)(_secondary["default"][800], 0.54),
      60: (0, _styles.alpha)(_secondary["default"][800], 0.6),
      62: (0, _styles.alpha)(_secondary["default"][800], 0.62),
      86: (0, _styles.alpha)(_secondary["default"][800], 0.86),
      87: (0, _styles.alpha)(_secondary["default"][800], 0.87)
    }
  },
  white: {
    2: (0, _styles.alpha)(_colors.common.white, 0.02),
    4: (0, _styles.alpha)(_colors.common.white, 0.04),
    8: (0, _styles.alpha)(_colors.common.white, 0.08),
    14: (0, _styles.alpha)(_colors.common.white, 0.14),
    24: (0, _styles.alpha)(_colors.common.white, 0.24),
    38: (0, _styles.alpha)(_colors.common.white, 0.38),
    50: (0, _styles.alpha)(_colors.common.white, 0.5),
    54: (0, _styles.alpha)(_colors.common.white, 0.54),
    60: (0, _styles.alpha)(_colors.common.white, 0.6),
    70: (0, _styles.alpha)(_colors.common.white, 0.7),
    87: (0, _styles.alpha)(_colors.common.white, 0.87)
  }
};
var _default = opacity;
exports["default"] = _default;